import React from "react";
import { useApp, Wrapper } from "@hygraph/app-sdk-react";

function CheckInstall() {
  const { installation } = useApp();
  if (installation.status === "COMPLETED") {
    return <div>Installed</div>;
  }
  return <Install />;
}

function Install() {
  const { updateInstallation } = useApp();

  return (
    <button
      onClick={() => {
        updateInstallation({ status: "COMPLETED", config: {} });
      }}
    >
      Install App
    </button>
  );
}

export default function Setup() {
  return (
    <Wrapper>
      <CheckInstall />
    </Wrapper>
  );
}
